var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-layout',{attrs:{"layout":"C"}},[_c('div',{staticClass:"layout-search"},[_c('div',[_vm._v("知识库查看")])]),_c('div',{staticClass:"layout-function"}),_c('div',{staticClass:"layout-result"})])
}
var staticRenderFns = []

export { render, staticRenderFns }